import { Menu } from '@mui/material';
import styled from '@emotion/styled';

export const DropdownMenu = styled(Menu)`
  box-shadow: none;
`;
